export default "__VITE_ASSET__oD0luz9N__"